import Bars3Icon from "@heroicons/react/24/outline/Bars3Icon";
import UserIcon from "@heroicons/react/24/outline/UserIcon";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { Button, Dropdown, Navbar } from "react-daisyui";
import { Link } from "react-router-dom";
import { themeChange } from "theme-change";
import ThemeSelector from "../components/ThemeSelector";
import { types } from "../graphql";
import { useAuth } from "../hooks/useAuth";
import NotificationsIcon from "./NotificationsIcon";

function Header({
  closeSidebar,
  currentUser,
  zone,
}: {
  currentUser: types.User | null;
  closeSidebar: () => void;
  zone: types.Zone | null;
}) {
  const Auth = useAuth();
  const queryClient = useQueryClient();
  const [currentTheme, setCurrentTheme] = useState(
    localStorage.getItem("theme"),
  );

  useEffect(() => {
    themeChange(false);
    // 👆 false parameter is required for react project
    if (currentTheme === null) {
      if (
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
      ) {
        setCurrentTheme("dark");
      } else {
        setCurrentTheme("light");
      }
    }
  }, [currentTheme]);

  function logoutUser() {
    Auth.signOut();
    queryClient.invalidateQueries();
  }

  return (
    <>
      <Navbar className="z-10 min-h-fit bg-base-100 p-1 shadow-lg">
        <Navbar.Start className="gap-2">
          <Button
            className="btn-ghost h-auto min-h-fit w-auto min-w-fit p-2 lg:hidden"
            onClick={closeSidebar}
          >
            <Bars3Icon className="h-6 w-6" />
          </Button>
          <Link to={"/"} className="flex flex-row items-center font-semibold">
            <img
              className="inline-block h-10 max-h-fit w-10 max-w-fit rounded p-2"
              src="/IconOnly_Transparent_NoBuffer.png"
              alt="Bandwagon Logo"
            />
            <div className="hidden md:inline">Bandwagon</div>
          </Link>
        </Navbar.Start>
        <Navbar.Center>
          {/* Menu toogle for mobile view or small screen */}
          {/* TODO - Populate from zone title */}
          <div className="text-lg font-semibold">{zone?.title ?? "Home"}</div>
        </Navbar.Center>

        <Navbar.End className="gap-1">
          <ThemeSelector />

          <NotificationsIcon currentUser={currentUser} zone={zone} />

          {/* Profile icon, opening menu on click */}
          <Dropdown end className="z-10 font-sans" vertical="bottom">
            <Dropdown.Toggle
              className="avatar btn btn-ghost h-auto min-h-fit w-auto min-w-fit rounded-md p-1"
              button={false}
            >
              {Auth.isAuthenticated() ? (
                currentUser?.avatar ? (
                  <img
                    src={currentUser.avatar}
                    alt="avatar"
                    className="max-w-8 max-h-8 rounded-lg p-0"
                  />
                ) : (
                  <div className="h-8 w-8 p-0 ">
                    {currentUser?.username.substring(0, 1)}
                  </div>
                )
              ) : (
                <UserIcon
                  className={
                    "h-8 w-8 p-1 " +
                    (currentTheme === "dark" ? "swap-on" : "swap-off")
                  }
                />
              )}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {Auth.isAuthenticated() ? (
                <Dropdown.Item>
                  <button onClick={logoutUser}>Logout</button>
                </Dropdown.Item>
              ) : (
                <>
                  <Dropdown.Item anchor={false}>
                    <Link to="/register">Register</Link>
                  </Dropdown.Item>
                  <Dropdown.Item anchor={false}>
                    <Link to="/login">Login</Link>
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </Navbar.End>
      </Navbar>
    </>
  );
}

export default Header;
